import { FC, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
import { selectQuiz } from 'store/quiz/quizzesSelectors';
import { selectQuizFormSidebar } from 'store/app/appSelectors';
// Components
import Icon from 'components/Icon';
import { IconButton } from 'components/Buttons';
import { Loader } from 'components/Utilities';
import QuizMenu from './QuizMenu';
import PagesMenu from './PagesMenu';
import PostQuizPagesMenu from './PostQuizPagesMenu';
import CorrectAnswersMenu from './CorrectAnswersMenu';
// MUI
import { useMediaQuery } from '@material-ui/core';
// Icons
import { FaEye, FaTimes } from 'react-icons/fa';

type Props = {
  size?: 'default' | 'small';
}

const QuizFormSidebar:FC<Props> = ({ size = 'default' }) => {
  const { search } = useLocation<{ search:string }>();
  const dispatch = useAppDispatch();

  const isSmallScreen = useMediaQuery('(max-width: 1023px)');
  const width = size === 'default' ? '25%' : '20%';

  const params = new URLSearchParams(search);
  const activeTab = params.get('tab') || 'quiz';

  const quizFormSidebar = useAppSelector(selectQuizFormSidebar);
  const quiz = useAppSelector(selectQuiz);

  const isQuizMenuActive = !activeTab || activeTab === 'quiz';
  const isPagesMenuActive = activeTab === 'pages';
  const isPostQuizPagesMenuActive = activeTab === 'postQuizPages';
  const isCorrectAnswersMenuActive = activeTab === 'correctAnswers';
  const isLiveLeaderboardMenuActive = activeTab === 'liveLeaderboard';

  const handelToggleSidebar = () => {
    dispatch(appActions.toggleQuizFormSidebar());
  }

  const handleTogglePreview = () => {
    dispatch(appActions.toggleQuizFormPreview())
  }

  if ( !quiz ) return <Loader />;
  if ( isLiveLeaderboardMenuActive ) return null;
  return (
    <Fragment>
      {quizFormSidebar ? (
        <div
          className="
            fixed top-0 left-0 w-full h-full z-40
            tablet:hidden
          "
          style={{ backgroundColor: 'rgba(0,0,0,0.68)'}}
          onClick={handelToggleSidebar}
        />
      ) : null}
      <div className="
        flex tablet:hidden
        items-center p-4
      ">
        <IconButton
          onClick={handelToggleSidebar}
          className="mr-2"
        ><Icon icon="menu" /></IconButton>
        <span className="flex-grow"></span>
        <IconButton
          className="flex items-center justify-center"
          onClick={handleTogglePreview}
        ><FaEye /></IconButton>
      </div>
      <div
        style={{ width: isSmallScreen ? '100%' : width }}
        className={`
          max-h-full
          fixed tablet:relative
          left-0 tablet:left-auto
          bottom-0 tablet:bottom-auto
          transform tablet:translate-y-0
          tablet:flex-shrink-0 
          overflow-y-auto
          z-50 tablet:z-10
          ${quizFormSidebar ? 'translate-y-0' : 'translate-y-full'}
          flex flex-col
        `}
      >
        <div className="tablet:hidden">
          <div className="text-right p-4">
            <IconButton
              onClick={handelToggleSidebar}
            ><FaTimes /></IconButton>
          </div>
          <div className="divider my-0" />
        </div>
        {isQuizMenuActive ? <QuizMenu /> : null}
        {isPagesMenuActive ? <PagesMenu /> : null}
        {isPostQuizPagesMenuActive ? <PostQuizPagesMenu /> : null}
        {isCorrectAnswersMenuActive ? <CorrectAnswersMenu /> : null}
      </div>
    </Fragment>
  )
}

export default QuizFormSidebar;
